import {SiteContactForm} from '../../../fields/siteContact/types'
import {Contact} from '../../../types'

export const buildSiteContactForm = (contacts?: {
  orderPlacer?: Contact
  siteContact?: Contact
}): SiteContactForm => {
  return {
    siteContact: {
      name: contacts?.siteContact?.name ?? '',
      phoneNumber: contacts?.siteContact?.phoneNumber ?? undefined // Start as undefined to avoid validation errors
    }
  }
}
